import {SET_VA_SELECTED} from '../actions/actionTypes'

const initialState = {
    selectedVA: 0,
}

const vaView = (state = initialState, action) => {
    switch (action.type) {
        case SET_VA_SELECTED:
            return Object.assign({}, state, {
                selectedVA: action.value
            })
        default:
            return state
    }
}

export default vaView